import styles from "@/asserts/styles/formSection.module.less";
import ModalSectionHeader from "@/components/ui/ModalSectionHeader";
import { MaterialFileFormFields } from "@/components/commonFormItems/MaterialFileFormFields";
import { Col, Form, Input, Row, Select } from "antd";
import type { LowValuePurchaseRequisitionFormValue } from "../../type";
import { CascaderFields } from "../CascaderFields";
import { purchaseGroupOptions } from "@/constants";
import { useFormEditable } from "../../hooks/useFormEditable";
import { useExistFlowHistory } from "@/hooks/services/useFlow";
import { useModal } from "@/hooks/modals/useModal";
import { usePurchaseRequestDetail } from "../../hooks/usePurchaseRequest";
import { purchaseManagerAuditNodeCodesForLow } from "../../constant";
import { useTranslation } from "react-i18next";

export const ApplicationInfoFormFields = () => {
  const { t } = useTranslation("purchaseRequestManagement");
  const { t: tCommon } = useTranslation("common");

  const { props } = useModal("PURCHASE_REQUEST");
  const { recordId } = props;
  const detail = usePurchaseRequestDetail(recordId);

  const form = Form.useFormInstance<LowValuePurchaseRequisitionFormValue>();

  const {
    isMainFormDisabled,
    isPurchasingStaffFormFieldsDisabled,
    isPurchaseManagerAuditFormFieldsDisabled,
  } = useFormEditable();

  const shouldDisabled =
    isPurchaseManagerAuditFormFieldsDisabled &&
    isPurchasingStaffFormFieldsDisabled;

  const shouldShowContractRequiredField = useExistFlowHistory(
    purchaseManagerAuditNodeCodesForLow,
    detail?.insId,
  );

  return (
    <div className={styles.formSection}>
      <ModalSectionHeader title={t("申请信息")} />

      <div className={styles.sectionBody}>
        <Row gutter={49}>
          <CascaderFields />

          <Col span={8}>
            <Form.Item<LowValuePurchaseRequisitionFormValue>
              name="isCurrently"
              label={t("是否有物料编号")}
            >
              <Select
                placeholder={t("请选择")}
                options={[
                  { label: tCommon("是"), value: 1 },
                  { label: tCommon("否"), value: 0 },
                ]}
                allowClear
                onChange={(value) => {
                  if (value === 1) {
                    form.setFieldsValue({ itemList: [] });
                  } else {
                    form.setFieldsValue({ itemList: [{}] });
                  }
                }}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={49}>
          <Col span={8}>
            <Form.Item<LowValuePurchaseRequisitionFormValue>
              name="purchaseGroup"
              label={t("采购组")}
              rules={[
                {
                  required: true,
                  message: t("请选择采购组"),
                },
              ]}
            >
              <Select
                placeholder={t("请选择")}
                options={purchaseGroupOptions}
                disabled={shouldDisabled}
              />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item<LowValuePurchaseRequisitionFormValue>
              name="isSuggestedSupplier"
              label={t("是否指定建议供应商")}
              rules={[
                {
                  required: true,
                  message: t("请选择是否指定建议供应商"),
                },
              ]}
            >
              <Select
                placeholder={t("请选择")}
                options={[
                  { label: tCommon("是"), value: 1 },
                  { label: tCommon("否"), value: 0 },
                ]}
              />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item<LowValuePurchaseRequisitionFormValue>
              name="suggestedSupplierName"
              label={t("指定建议供应商名称")}
            >
              <Input placeholder={t("请输入")} />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item<LowValuePurchaseRequisitionFormValue>
              name="suggestedReason"
              label={t("指定建议供应商原因")}
            >
              <Input.TextArea rows={2} placeholder={t("请输入")} />
            </Form.Item>
          </Col>

          {shouldShowContractRequiredField && (
            <Col span={8}>
              <Form.Item<LowValuePurchaseRequisitionFormValue>
                name="contractRequired"
                label={t("是否需要合同")}
                rules={[
                  {
                    required: true,
                    message: t("请选择是否需要合同"),
                  },
                ]}
              >
                <Select
                  placeholder={t("请选择")}
                  options={[
                    { label: tCommon("是"), value: 1 },
                    { label: tCommon("否"), value: 0 },
                  ]}
                  disabled={isPurchaseManagerAuditFormFieldsDisabled}
                />
              </Form.Item>
            </Col>
          )}
        </Row>

        <MaterialFileFormFields
          fieldName="requirementsFiles"
          label={t("指定建议供应商相关附件")}
          required={false}
          hiddenRemove={isMainFormDisabled}
        />
      </div>
    </div>
  );
};
